import { UpdatePostSummaryStore, updatePostSummaryUseCase } from "./updatePostSummaryUseCase";

const setPostSummaryUseCase = (store: UpdatePostSummaryStore, summary: string) =>
    updatePostSummaryUseCase(store, summary);

export { setPostSummaryUseCase }